// extracted by mini-css-extract-plugin
export default {"stamp":"stamp-0573","fadeOut":"fadeOut-6a04","gradient":"gradient-917a"};